import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import { toast } from 'react-toastify'

import EditHeaderData from '../../../../../presentation/pages/doctors/profile/editHeaderData'

import { makeDoctorsEdit } from '../../../../usecases/doctors/remote-doctors-factory'
import { makeUsers } from '../../../../usecases/users/remote-users-factory'

import { useMe } from '../../../../../presentation/contexts/me'

const MakeEditHeaderData = () => {
  document.title = 'BuscarMédicos - Editar Dados'

  const history = useHistory()

  const [errorMessage] = useState<string | null>('')

  const { me } = useMe()

  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    document: [
      {
        id: 0,
        url: '',
      },
    ],
  })

  useEffect(() => {
    const fetchData = async () => {
      if (!me) {
        return
      }

      try {
        const response = await makeUsers().loadDoctorById(me.id)
        setUser(response)
      } catch (error) {
        toast.error('Erro ao carregar dados do usuário.')
      }
    }

    fetchData()
  }, [me])

  const dataForm = [
    {
      items: [
        {
          component: 'InputGroup',
          style: { display: 'grid', gridTemplateColumns: '1fr 1fr' },
          inputs: [
            {
              name: 'firstName',
              component: 'Input',
              value: user.firstName,
              placeholder: 'Digite aqui',
              type: 'text',
              title: 'Primeiro nome',
              label: 'Primeiro nome',
              required: true,
              validations: 'inputRequired',
              stylesContainer: { marginBottom: '15px' },
            },
            {
              name: 'lastName',
              component: 'Input',
              value: user.lastName,
              placeholder: 'Digite aqui',
              type: 'text',
              title: 'Sobrenome',
              label: 'Sobrenome',
              required: true,
              validations: 'inputRequired',
              style: { marginBottom: '15px' },
            },
          ],
        },
        {
          component: 'InputGroup',
          style: { display: 'grid', gridTemplateColumns: '1fr 1fr' },
          inputs: [
            {
              name: 'email',
              component: 'Input',
              value: user.email,
              placeholder: 'Digite aqui',
              type: 'email',
              title: 'E-mail',
              label: 'E-mail',
              required: true,
              validations: 'emailRequired',
              style: { marginBottom: '15px' },
            },
            {
              name: 'whatsapp',
              component: 'InputPhone',
              value: user.phone,
              placeholder: 'Digite aqui',
              type: 'tel',
              title: 'WhatsApp',
              label: 'WhatsApp',
              required: true,
              validations: 'inputRequired',
              style: { marginBottom: '15px' },
            },
          ],
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar alterações',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const onSubmit = async (values: any): Promise<void> => {
    try {
      if (!me) {
        return
      }

      if (!user.firstName && !user.lastName && !user.email && !user.phone) {
        await makeDoctorsEdit().update(me.id, {
          email: values.email,
          firstName: values.firstName,
          lastName: values.lastName,
          phone: values.whatsapp,
        })
      } else {
        const updatedFields: any = {}

        if (user.email !== values.email) {
          updatedFields.email = values.email
        }
        if (user.firstName !== values.firstName) {
          updatedFields.firstName = values.firstName
        }
        if (user.lastName !== values.lastName) {
          updatedFields.lastName = values.lastName
        }
        if (user.phone !== values.whatsapp) {
          updatedFields.phone = values.whatsapp
        }

        if (Object.keys(updatedFields).length > 0) {
          await makeDoctorsEdit().update(me.id, updatedFields)
        }
      }

      localStorage.setItem('userEmail', values.email)
      history.goBack()
    } catch (error: any) {
      toast.error(`Erro ao salvar alterações: ${error.message}`)
    }
  }

  const name = `${user.firstName} ${user.lastName}`

  const imageUrl = user.document.find((doc) => doc.url.startsWith('images/'))?.url

  return (
    <EditHeaderData
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      name={name}
      email={user.email}
      phone={user.phone}
      imageUrl={imageUrl}
    />
  )
}

export default MakeEditHeaderData
